"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClient = exports.initClient = void 0;
const api_client_1 = __importDefault(require("src/utils/api-client"));
const client_config_1 = __importDefault(require("src/utils/client-config"));
let apiClient;
const initClient = (location) => {
    const { host, pathname, search } = location;
    const config = (0, client_config_1.default)({ host, pathname, search, isHaveUxQuestions: false });
    // даем переопределять хост через конфиги для сторибука и локальных запусков
    const APIConfig = Object.assign({ host }, config.api);
    apiClient = new api_client_1.default(APIConfig);
    return apiClient;
};
exports.initClient = initClient;
const getClient = (loc = location) => {
    if (apiClient) {
        return apiClient;
    }
    return (0, exports.initClient)(loc);
};
exports.getClient = getClient;
